import React, { useState, useEffect } from 'react';
import useLocalStorage from 'use-local-storage';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { dominioDemandaCirurgica } from '../../config/database';

export default function ImpressaoSolicitacaoAIHJustificativaInternacao({ alterarPassoDadosAIH }) {
  const [solicitacaoAIH, setSolicitacaoAIH] = useLocalStorage('solicitacaoAIH', undefined);
  const [listaCID, setListaCID] = useState([]);

  const listarCIDs = () => {
    dominioDemandaCirurgica.get(`/api/cid`).then(response => {
      setListaCID(response.data);
    });
  };

  useEffect(() => {
    listarCIDs();
  }, []);

  const handleSubmit = e => {
    e.preventDefault();

    alterarPassoDadosAIH(2);
  };

  return (
    <Container style={{ height: '100%' }}>
      <b>Justificativa de internação</b>
      <br />
      <br />
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <TextField
              autoComplete="off"
              name="principaisSinaisSintomas"
              variant="outlined"
              fullWidth
              id="principaisSinaisSintomas"
              label="Principais sinais e sintomas clínicos"
              InputLabelProps={{ shrink: true }}
              value={solicitacaoAIH ? solicitacaoAIH.principaisSinaisSintomas : undefined}
              onChange={e => {
                const solicitacao = { ...solicitacaoAIH, principaisSinaisSintomas: e.target.value };
                setSolicitacaoAIH(solicitacao);
              }}
              inputProps={{ maxLength: 500, style: { textTransform: 'uppercase' } }}
              multiline
              rows={2}
              required
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              autoComplete="off"
              name="justificativasInternacao"
              variant="outlined"
              fullWidth
              id="justificativasInternacao"
              label="Condições que justificam a internação"
              InputLabelProps={{ shrink: true }}
              value={solicitacaoAIH ? solicitacaoAIH.justificativasInternacao : undefined}
              onChange={e => {
                const solicitacao = { ...solicitacaoAIH, justificativasInternacao: e.target.value };
                setSolicitacaoAIH(solicitacao);
              }}
              inputProps={{ maxLength: 500, style: { textTransform: 'uppercase' } }}
              multiline
              rows={2}
              required
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              autoComplete="off"
              name="principaisResultadosProvasDiagnosticas"
              variant="outlined"
              fullWidth
              id="principaisResultadosProvasDiagnosticas"
              label="Principais resultados de provas diagnósticas (Resultados de exames realizados)"
              InputLabelProps={{ shrink: true }}
              value={
                solicitacaoAIH ? solicitacaoAIH.principaisResultadosProvasDiagnosticas : undefined
              }
              onChange={e => {
                const solicitacao = {
                  ...solicitacaoAIH,
                  principaisResultadosProvasDiagnosticas: e.target.value,
                };
                setSolicitacaoAIH(solicitacao);
              }}
              inputProps={{ maxLength: 500, style: { textTransform: 'uppercase' } }}
              multiline
              rows={2}
              required
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <TextField
              autoComplete="off"
              name="diagnosticoInicial"
              variant="outlined"
              fullWidth
              id="diagnosticoInicial"
              label="Diagnóstico inicial"
              InputLabelProps={{ shrink: true }}
              value={solicitacaoAIH ? solicitacaoAIH.diagnosticoInicial : undefined}
              disabled
              inputProps={{ maxLength: 50, style: { textTransform: 'uppercase' } }}
              required
            />
          </Grid>
          <Grid item xs={2} sm={2}>
            <Autocomplete
              id="cidPrincipal"
              disableClearable
              options={listaCID}
              getOptionLabel={CID => `${CID.codigo}`}
              fullWidth
              value={solicitacaoAIH ? solicitacaoAIH.cidPrincipal : undefined}
              onChange={(e, value) => {
                const solicitacao = {
                  ...solicitacaoAIH,
                  cidPrincipal: value,
                  diagnosticoInicial: value.descricao,
                };
                setSolicitacaoAIH(solicitacao);
              }}
              renderInput={params => (
                <TextField {...params} label="CID 10 principal" variant="outlined" required />
              )}
            />
          </Grid>
          <Grid item xs={2} sm={2}>
            <Autocomplete
              id="cidSecundario"
              disableClearable
              options={listaCID}
              getOptionLabel={CID => `${CID.codigo}`}
              fullWidth
              value={solicitacaoAIH ? solicitacaoAIH.cidSecundario : undefined}
              onChange={(e, value) => {
                const solicitacao = { ...solicitacaoAIH, cidSecundario: value };
                setSolicitacaoAIH(solicitacao);
              }}
              renderInput={params => (
                <TextField {...params} label="CID 10 secundário" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={2} sm={2}>
            <Autocomplete
              id="cidCausasAssociadas"
              disableClearable
              options={listaCID}
              getOptionLabel={CID => `${CID.codigo}`}
              fullWidth
              value={solicitacaoAIH ? solicitacaoAIH.cidCausasAssociadas : undefined}
              onChange={(e, value) => {
                const solicitacao = { ...solicitacaoAIH, cidCausasAssociadas: value };
                setSolicitacaoAIH(solicitacao);
              }}
              renderInput={params => (
                <TextField {...params} label="CID 10 causas associadas" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={8} sm={8} />
          <Grid item xs={2} sm={2}>
            <Button
              onClick={() => {
                alterarPassoDadosAIH(0);
              }}
              style={{ float: 'right' }}
              variant="contained"
              color="warning"
            >
              Voltar
            </Button>
          </Grid>
          <Grid item xs={2} sm={2}>
            <Button type="submit" variant="contained" color="primary" style={{ float: 'right' }}>
              Próximo
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
